import { apiClient } from './axiosInstance';
import {
  IFetchInvitationsParams,
  IAddInvitationData,
} from 'features/invitationLinksList/invitationLinksListTypes';

export const fetchInvitationsList = async (params: IFetchInvitationsParams | void) => {
  if (params) {
    const { skip, take, showAccepted, search } = params;
    const skipQuery = `skip=${skip}`;
    const takeQuery = `&take=${take}`;
    const showAcceptedQuery = `&showAccepted=${showAccepted}`;
    const searchQuery = search && search.length > 0 ? `&search=${search}` : '';
    const queryStr = `?${skipQuery}${takeQuery}${showAcceptedQuery}${searchQuery}`;
    return await apiClient.get(`/invitations${queryStr}`);
  } else {
    return await apiClient.get(`/invitations`);
  }
};

export const addInvitation = async (invitationData: IAddInvitationData[]) => {
  return await apiClient.post('/invitations', invitationData);
};

export const reactivateInvitation = async (invitationId: number) => {
  return await apiClient.patch(`/invitations/${invitationId}/reactivate`);
};

export const deleteInvitation = async (invitationId: number) => {
  return await apiClient.delete(`/invitations/${invitationId}`);
};
